const darkTheme = {
  background: {
    primary: '#C5C5C5',
    secondary: '#333333',
    tertiary: '#202020',
    highlight: '#eea2a2',
  },
  font: {
    primary: '#FFFFFF',
    secondary: '#EFEFEF',
    tertiary: '#C5C5C5',
    highlight: '#eea2a2',
  },
};

export default darkTheme;
